import React, { Component } from "react";
import { connect } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { withTranslation } from "react-i18next";
import { getUrlWord } from "../../util/helpers/Helpers";
import { getAllRounds } from "../../actions/PhotowallActions";
import "./PhotosFrame.scss";

class PhotosFrame extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loader: false,
      tileIndices: [-1, -1, -1],
      nextPtr: 0,
      animatingCol: null,
      colCursor: 0,
      seeded: false,
      imageLoaded: false,
      imageError: false,
      logoLoaded: false,
      logoError: false,
    };

    this._pool = [];
    this._rotateTimer = null;
    this._exitTimeout = null;
  }

  componentDidMount() {
    var hash = getUrlWord(this.props.match.url, this.props.location.hash);
    if (hash) {
      this.props.dispatch(getAllRounds(hash, this.props.dispatch));
      this.setState({ loader: true });
    }
  }

  componentDidUpdate(prevProps) {
    var competition = this.props.competition;
    var prevCompetition = prevProps.competition;

    var wasUnavailable = !prevCompetition || !prevCompetition.dataAvailable;
    var nowAvailable = competition && competition.dataAvailable;

    if (wasUnavailable && nowAvailable) {
      this._applyTheme();
    }

    // Hide loader when competition data is loaded
    if (
      competition &&
      prevCompetition &&
      prevCompetition.loader !== competition.loader
    ) {
      this.setState({ loader: competition.loader });
    }

    var items = [];
    var newCount = items.length;
    var prevItems = [];
    var prevCount = prevItems.length;

    if (newCount >= 1 && !this.state.seeded) {
      this._pool = items.slice();
    } else if (newCount > prevCount && this.state.seeded) {
      this._pool = items.slice();
    }
  }

  componentWillUnmount() {
    // Clean up timers if any
    if (this._rotateTimer) {
      clearTimeout(this._rotateTimer);
    }
    if (this._exitTimeout) {
      clearTimeout(this._exitTimeout);
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    // Hide loader when competition data becomes available
    if (
      nextProps.competition &&
      nextProps.competition.dataAvailable &&
      (!this.props.competition || !this.props.competition.dataAvailable)
    ) {
      this.setState({ loader: false });
    }

    // Also hide when loader prop becomes false
    if (
      nextProps.competition &&
      this.props.competition &&
      this.props.competition.loader &&
      !nextProps.competition.loader
    ) {
      this.setState({ loader: false });
    }

    return true;
  }

  getImageUrlFromQuery = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('image');
  };

  handleImageLoad = () => {
    this.setState({ imageLoaded: true, imageError: false });
  };

  handleImageError = () => {
    this.setState({ imageLoaded: true, imageError: true });
  };

  handleLogoLoad = () => {
    this.setState({ logoLoaded: true, logoError: false });
  };

  handleLogoError = () => {
    this.setState({ logoLoaded: true, logoError: true });
  };

  _applyTheme() {
    var competition = this.props.competition;
    if (!competition) return;
    var data = competition.data;
    if (!data) return;

    if (data.bgColor) {
      var root = document.getElementById("root");
      if (root) {
        root.style.backgroundColor = data.bgColor;
        root.style.minHeight = "100vh";
      }
    }

    var bgFile = "";
    if (data.desktopBg && data.desktopBg.file) {
      bgFile = data.desktopBg.file;
    }
    if (bgFile) {
      var styles = [
        "body {",
        "  background: url(" + bgFile + ") no-repeat center center fixed;",
        "}",
        "body:after {",
        '  content: "";',
        "  position: fixed;",
        "  top: 0; height: 100vh; left: 0; right: 0; z-index: -1;",
        "  background: url(" + bgFile + ") center center;",
        "  -webkit-background-size: cover;",
        "  -moz-background-size: cover;",
        "  -o-background-size: cover;",
        "  background-size: cover;",
        "}",
      ].join("\n");
      var styleEl = document.createElement("style");
      styleEl.innerText = styles;
      document.head.appendChild(styleEl);
    }

    if (data.name) {
      document.title = data.name.replace(/(<([^>]+)>)/gi, " ").trim();
    }

    if (data.cssContentUrl) {
      var cssRef = document.createElement("link");
      cssRef.setAttribute("rel", "stylesheet");
      cssRef.setAttribute("type", "text/css");
      cssRef.setAttribute("href", data.cssContentUrl);
      document.getElementsByTagName("head")[0].appendChild(cssRef);
    }

    if (data.fontUrl) {
      var fontRef = document.createElement("link");
      fontRef.setAttribute("rel", "stylesheet");
      fontRef.setAttribute("type", "text/css");
      fontRef.setAttribute("href", data.fontUrl);
      document.getElementsByTagName("head")[0].appendChild(fontRef);
    }
  }

  _getLogoFile() {
    var competition = this.props.competition;
    if (competition && competition.allImages && competition.allImages.length) {
      for (var i = 0; i < competition.allImages.length; i++) {
        if (competition.allImages[i].type === "logo-bg") {
          return competition.allImages[i].file;
        }
      }
    }
    if (
      competition &&
      competition.data &&
      competition.data.logoBg &&
      competition.data.logoBg.file
    ) {
      return competition.data.logoBg.file;
    }
    return null;
  }

  _isVideo(url) {
    if (!url) return false;
    var ext = url.split(/[#?]/)[0].split(".").pop().trim().toLowerCase();
    return ["mp4", "avi", "webm", "mov"].indexOf(ext) !== -1;
  }

  render() {
    var competition = this.props.competition;
    if (!competition || !competition.data) return <div />;

    const imageUrl = this.getImageUrlFromQuery();

    var data = competition.data;
    var logoUrl = this._getLogoFile();
    var bgFile =
      data.desktopBg && data.desktopBg.file ? data.desktopBg.file : "";
    var showLogo = logoUrl;

    var borderColor = data.borderColor || "rgba(255,255,255,0.8)";
    var primaryColor = data.primaryColor || "#ffffff";

    return (
      <React.Fragment>
        {this._isVideo(bgFile) ? (
          <video
            autoPlay={true}
            muted={true}
            loop={true}
            playsInline={true}
            id="myVideo"
          >
            <source src={bgFile} type="video/mp4" />
          </video>
        ) : null}

        {/* Loader - only show when loader state is true */}
        {this.state.loader ? (
          <div className="loaderCss">
            <style
              dangerouslySetInnerHTML={{ __html: "body{overflow:hidden;}" }}
            />
            <div className="loader">
              <FadeLoader
                size={150}
                color={"#ffffff"}
                loading={this.state.loader}
              />
            </div>
          </div>
        ) : null}

        <div className="photo_frame_section">
          {/* Logo Container */}
          {showLogo && (
            <div className="logo-container">
              {!this.state.logoLoaded && !this.state.logoError && (
                <div className="logo-placeholder">Loading logo...</div>
              )}
              {this.state.logoError && (
                <div className="logo-placeholder">Logo failed to load</div>
              )}
              <img
                src={logoUrl}
                className="photo-frame-logo"
                alt={data.name || "Logo"}
                onLoad={this.handleLogoLoad}
                onError={this.handleLogoError}
                style={{
                  display: this.state.logoLoaded ? 'block' : 'none'
                }}
              />
            </div>
          )}

          {/* Image Container */}
          <div className="image-container">
            {imageUrl ? (
              <>
                {!this.state.imageLoaded && !this.state.imageError && (
                  <div className="image-placeholder">Loading image...</div>
                )}
                {this.state.imageError && (
                  <div className="image-placeholder error">
                    Failed to load image. Please check the URL.
                  </div>
                )}
                <img
                  src={imageUrl}
                  className="photo-frame-image"
                  alt="Displayed from URL"
                  onLoad={this.handleImageLoad}
                  onError={this.handleImageError}
                  style={{
                    display: this.state.imageLoaded ? 'block' : 'none'
                  }}
                />
              </>
            ) : (
              <div className="image-placeholder">
                No image URL provided. Add ?image=URL to the address
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

var mapStateToProps = function (state, ownProps) {
  var prj = state.default;
  return Object.assign({}, ownProps, {
    competition: prj.competition,
    comp: prj.competition.data,
    locale: prj.locale,
  });
};

var mapDispatchToProps = function (dispatch) {
  return { dispatch: dispatch };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(PhotosFrame));
